import { message, notification } from "antd";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { EmitError } from "../../utils/EmitError";
import { urlImgEntidades } from "../../services/urls";
import useAuth from "../../hooks/useAuth";
import InstitucionalService from "../../services/http/services/InstitucionalService";

export default function useInstitucional() {

    const { idParam }: any = useParams();

    const [dataEntity, setDataEntity] = useState(
        JSON.parse(localStorage.getItem("@GovfacilGestor:selectedEntity")!) || null
    );

    const refController = useRef(new AbortController());

    const refForm = useRef<any>(null);
    const { setUseractiveEntity, userCan } = useAuth();

    const refIdContrato = useRef<any>(null);
    const refEntidadeInterface = useRef<null | any>(null);

    const refImagemCarregadaLight = useRef<any>(null);
    const refImagemCarregadaDark = useRef<any>(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [isSalvarOrEditar, setIsSalvarOrEditar] = useState(false);
    const [editorState, setEditorState] = useState<any>(
        EditorState.createEmpty()
    );
    const [entidade, setEntidade] = useState();
    const [defaultEditorState, setdefaultEditorState] = useState<any>();
    const [loadingCampoUpload, setLoadingCampoUpload] = useState<boolean>(false);
    const [imageUrlLight, setImageUrlLight] = useState<any>(null);
    const [imageUrlDark, setImageUrlDark] = useState<any>(null);

    const downloadImage = useCallback((url: string) => {
        // Faz uma solicitação para buscar os dados da imagem
        fetch(url)
            .then((response) => response.blob())
            .then((blob) => {
                // Cria um elemento 'a' para iniciar o download
                const element = document.createElement("a");
                element.href = URL.createObjectURL(blob);
                element.download = "logo.png";
                element.click();
            })
            .catch((error) => {
                window.open(url);
            });
    }, []);

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);

    useEffect((): void => {
        setIsSalvarOrEditar(true);
        const buscaDadosIniciais = async () => {

            refController.current = new AbortController();

            try {

                if (dataEntity) {

                    //caso for editar ativar o loading
                    setLoadingPage(true);

                    refEntidadeInterface.current = dataEntity?.entity;

                    const data = await InstitucionalService.getGestorEntidade(dataEntity?.entity?.id, refController.current.signal)

                    if (data) {


                        setIsSalvarOrEditar(false);

                        refForm.current.setFieldsValue({
                            id: data?.id,
                            name: data?.name,
                            url: data.url,
                            instagramProfile: data.instagramProfile,
                        });

                        setImageUrlLight(
                            urlImgEntidades +
                            "/" +
                            data.logo_light
                        );

                        setImageUrlDark(
                            urlImgEntidades +
                            "/" +
                            data.logo_dark
                        );


                        if (
                            data.description !== null && data.description !== undefined
                        ) {
                            const contentBlocks = htmlToDraft(
                                data.description
                            );

                            const sampleEditorContent =
                                ContentState.createFromBlockArray(
                                    contentBlocks.contentBlocks,
                                    contentBlocks.entityMap
                                );
                            const editorState =
                                EditorState.createWithContent(sampleEditorContent);

                            setEditorState(editorState);
                            // setdefaultEditorState(sampleEditorContent)
                        }
                    }

                }

                setLoadingPage(false);
            } catch (error) {
                setLoadingPage(false);
                EmitError(error, true, "useEffect");
            }
        };

        if (userCan('manage_entity')) {
            buscaDadosIniciais();
        }

    }, [idParam, dataEntity]);


    const getBase64 = useCallback((img: any, callback: any) => {
        try {
            const reader = new FileReader();
            reader.addEventListener("load", () => callback(reader.result));
            reader.readAsDataURL(img);
        } catch (error) {

        }
    }, []);

    const beforeUpload = useCallback((file: any) => {
        // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isJpgOrPng = file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("Somente arquivos png são suportados!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        return isJpgOrPng && isLt2M;
    }, []);

    const onchangeEditor = useCallback((editorState: any): void => {
        setEditorState(editorState);
    }, []);

    const handleChangeLight = useCallback((info: any) => {
        refImagemCarregadaLight.current = info;

        getBase64(info.file.originFileObj, (imageUrl: any) => {
            setLoadingCampoUpload(false);
            setImageUrlLight(imageUrl);
        });
    }, []);

    const handleChangeDark = useCallback((info: any) => {
        refImagemCarregadaDark.current = info;

        getBase64(info.file.originFileObj, (imageUrl: any) => {
            setLoadingCampoUpload(false);
            setImageUrlDark(imageUrl);
        });
    }, []);

    useEffect(() => {
        if (entidade !== undefined) {
            setEntidade(entidade);
        }
    }, [entidade]);

    const onClickBotaoEditar = useCallback((): void => {

        const editarEntidadeContrato = async (values: any) => {
            try {
                setLoadingPage(true);
                const formData = new FormData();
                formData.append("description", values.description);
                formData.append("name", values.name);
                formData.append("url", values.url);
                formData.append("instagramProfile", values.instagramProfile);


                if (refImagemCarregadaLight.current !== null) {
                    formData.append(
                        "logo_light",
                        refImagemCarregadaLight.current.file.originFileObj
                    );
                }
                if (refImagemCarregadaDark.current !== null) {
                    formData.append(
                        "logo_dark",
                        refImagemCarregadaDark.current.file.originFileObj
                    );
                }

                const idEntidade = refForm.current.getFieldValue("id");


                const data = await InstitucionalService.setGestorEntidade(
                    idEntidade,
                    formData,
                    refController.current.signal
                )

                setLoadingPage(false);
                notification.success({
                    message: "Sucesso",
                    description: "Entidade atualizada com sucesso!",
                });

                refForm.current.setFieldsValue({
                    name: data.name,
                    url: data.url,
                    instagramProfile: data.instagramProfile,
                });

                setUseractiveEntity(data);

            } catch (error) {
                setLoadingPage(false);
                EmitError(error, true, "useEffect");
            }
        };

        refForm.current
            .validateFields()
            .then((values: any) => {
                values.description = draftToHtml(
                    convertToRaw(editorState.getCurrentContent())
                );
                values.contratoId = refIdContrato.current;
                editarEntidadeContrato(values);
            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: "Erro",
                    description: "Preencha os campos obrigatorios!",
                });
            });
    }, [editorState]);

    return {
        userCan,
        refForm,
        editorState,
        defaultEditorState,
        onchangeEditor,
        beforeUpload,
        handleChangeLight,
        imageUrlLight,
        downloadImage,
        handleChangeDark,
        imageUrlDark,
        isSalvarOrEditar,
        loadingPage,
        onClickBotaoEditar,
    }
}
